export const AtomchatButton = (bm, category, label, type) => {
  bm.add(type, {
    label: `<i class="webconnect-chat-dots-fill"></i><div>${label}</div>`,
    category: category,
    content: `<div data-gjs-type="atomchat" id="atomchat">
      <img src="https://public-webconnect.s3.amazonaws.com/atomchat.png" alt="atomchat" class="atomchat" />
    </div>`,
  });
};
export default (dc, label, type, config) => {
  const defaultType = dc.getType('default');
  const defaultModel = defaultType.model;
  dc.addType(type, {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          icon: '<i class="wb webconnect-chat-dots-fill"></i>',
          projectId: config.projectId,
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') == type) {
            return {
              type: type,
            };
          }
        },
      },
    ),
  });
};
